import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=6c6896ce&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/usr/src/motec/components/PageHeader.vue').default,ContactDetails: require('/usr/src/motec/components/contact/Details.vue').default})
